import { HttpErrorResponse } from '@angular/common/http';

type ValueOf<KycEventType> = KycEventType[keyof KycEventType];
type KycOnboardingEvent = ValueOf<{
    [K in KycLevel]: ValueOf<(typeof KYC_EVENTS)[K]>;
}>;

export enum KycLevel {
    LEVEL_1 = 'LEVEL_1',
    LEVEL_2 = 'LEVEL_2',
    LEVEL_3 = 'LEVEL_3',
    LEVEL_4 = 'LEVEL_4',
}

export const KYC_EVENTS = {
    [KycLevel.LEVEL_1]: {
        SIGNUP_BUSINESS_ADDRESS_SUCCESS: 'signup_business_address_success',
        SIGNUP_BUSINESS_ADDRESS_FAILED: 'signup_business_address_failed',
        SIGNUP_BUSINESS_ADDRESS_INITIATED: 'signup_business_address_initiated',
    },
    [KycLevel.LEVEL_2]: {
        ID_VERIFICATION_INITIATED: 'level_2_id_verification_initiated',
        ID_VERIFICATION_SUCCESS: 'level_2_id_verification_success',
        ID_VERIFICATION_FAILED: 'level_2_id_verification_failed',
        ID_VERIFICATION_ISSUES_INITIATED: 'level_2_id_verification_issues_initiated',
        ID_VERIFICATION_ISSUES_SUCCESS: 'level_2_id_verification_issues_success',
        ID_VERIFICATION_ISSUES_FAILED: 'level_2_id_verification_issues_failed',
        USER_KYC_LEVEL_2_SUCCESS: 'user_kyc_level_2_success',
    },
    [KycLevel.LEVEL_3]: {
        ADDRESS_UPDATE_FORM_INITIATED: 'address_update_form_initiaited',
        ADDRESS_UPDATE_FORM_SUCCESSFUL: 'address_update_form_successful',
        ADDRESS_UPDATE_FORM_FAILED: 'address_update_form_failed',
        BO_KYC_LEVEL_3_INITIATED: 'bo_kyc_level_3_initiated',

        START_KYCL3_UPGRADE_BANNER_INITIATIED: 'Start_KYCL3_Upgrade_banner_initiated',
        START_KYCL3_UPGRADE_BANNER_SUCCESS: 'Start_KYCL3_Upgrade_banner_success',
        START_KYCL3_UPGRADE_BANNER_FAILED: 'Start_KYCL3_Upgrade_banner_failed',

        START_KYCL3_UPGRADE_REQUIREMENTS_INITIATIED: 'Start_KYCL3_Upgrade_requirements_initiated',
        START_KYCL3_UPGRADE_REQUIREMENTS_SUCCESS: 'Start_KYCL3_Upgrade_requirements_success',
        START_KYCL3_UPGRADE_REQUIREMENTS_FAILED: 'Start_KYCL3_Upgrade_requirements_failed',

        START_KYCL3_UPGRADE_KYC_PROGRESS_INITIATIED: 'Start_KYCL3_Upgrade_kyc_progress_initiated',
        START_KYCL3_UPGRADE_KYC_PROGRESS_SUCCESS: 'Start_KYCL3_Upgrade_kyc_progress_success',
        START_KYCL3_UPGRADE_KYC_PROGRESS_FAILED: 'Start_KYCL3_Upgrade_kyc_progress_failed',

        PRIMER_KYCL3_REQUIREMENT_INITIATIED: 'Primer_KYCL3_Requirement_initiated',
        PRIMER_KYCL3_REQUIREMENT_SUCCESS: 'Primer_KYCL3_Requirement_success',
        PRIMER_KYCL3_REQUIREMENT_FAILED: 'Primer_KYCL3_Requirement_failed',

        OKHI_ADDRESS_COLLECTION_INITIATION_INITIATIED: 'OKHi_Address_Collection_Initiated_initiated',
        OKHI_ADDRESS_COLLECTION_INITIATION_SUCCESS: 'OKHi_Address_Collection_Initiated_success',
        OKHI_ADDRESS_COLLECTION_INITIATION_FAILED: 'OKHi_Address_Collection_Initiated_failed',

        OKHI_ADDRESS_COLLECTION_ON_SUCCESS_INITIATIED: 'OKHi_Address_Collection_on_Success_initiated',
        OKHI_ADDRESS_COLLECTION_ON_SUCCESS_SUCCESS: 'OKHi_Address_Collection_on_Success_success',
        OKHI_ADDRESS_COLLECTION_ON_SUCCESS_FAILED: 'OKHi_Address_Collection_on_Success_failed',

        OKHI_ADDRESS_COLLECTION_ON_ERROR_INITIATIED: 'OKHi_Address_Collection_on_Error_initiated',
        OKHI_ADDRESS_COLLECTION_ON_ERROR_SUCCESS: 'OKHi_Address_Collection_on_Error_success',
        OKHI_ADDRESS_COLLECTION_ON_ERROR_FAILED: 'OKHi_Address_Collection_onErrors_failed',

        INITIATE_MANUAL_ADDRESS_COLLECTION_INITIATED: 'Initiate_Manual_Address_Collection_initiated',
        INITIATE_MANUAL_ADDRESS_COLLECTION_SUCCESS: 'Initiate_Manual_Address_Collection_success',
        INITIATE_MANUAL_ADDRESS_COLLECTION_FAILED: 'Initiate_Manual_Address_Collection_failed',

        ADDRESS_COLLECTION_SUBMISSION_INITIATED: 'Address_Collection_Submission_initiated',
        ADDRESS_COLLECTION_SUBMISSION_SUCCESS: 'Address_Collection_Submission_success',
        ADDRESS_COLLECTION_SUBMISSION_FAILED: 'Address_Collection_Submission_failed',

        PHYSICAL_ADDRESS_VERIFICATION_INITIATED: 'physical_address_verification_initiated',
        PHYSICAL_ADDRESS_VERIFICATION_SUCCESS: 'physical_address_verification_success',
        PHYSICAL_ADDRESS_VERIFICATION_FAILED: 'physical_address_verification_failed',

        LOCATION_ACCESS_ADDRESS_VERIFICATION_INITIATIED: 'Location_Access_Address_verification_initiated',
        LOCATION_ACCESS_ADDRESS_VERIFICATION_SUCCESS: 'Location_Access_Address_verification_success',
        LOCATION_ACCESS_ADDRESS_VERIFICATION_FAILED: 'Location_Access_Address_verification_failed',

        GPS_COUNTRY_CHECK_INITIATED: 'GPS_Country_Check_initiated',
        GPS_COUNTRY_CHECK_SUCCESS: 'GPS_Country_Check_success',
        GPS_COUNTRY_CHECK_FAILED: 'GPS_Country_Check_failed',

        USER_COUNTRY_CHECK_INITIATED: 'User_Country_Check_initiated',
        USER_COUNTRY_CHECK_SUCCSS: 'User_Country_Check_success',
        USER_COUNTRY_CHECK_FAILED: 'User_Country_Check_failed',

        OKHI_DIGITAL_ADDRESS_VERIFICATION_INITIATION_INITIATED:'OKHi_Digital_Address_Verification_Initiated_initiated',
        OKHI_DIGITAL_ADDRESS_VERIFICATION_INITIATION_SUCCESS:'OKHi_Digital_Address_Verification_Initiation_success',
        OKHI_DIGITAL_ADDRESS_VERIFICATION_INITIATION_FAILED:'OKHi_Digital_Address_Verification_Initiation_failed',

        INDEMNITY_INITIATED:'indemnity_initiated',
        INDEMNITY_SUCCESS:'indemnity_success',
        INDEMNITY_FAILED:'indemnity_failed',

        ADDRESS_VERIFICATION_STATUS_INITIATED:'address_verification_status_initiated',
        ADDRESS_VERIFICATION_STATUS_SUCCESS:'address_verification_status_success',
        ADDRESS_VERIFICATION_STATUS_FAILED:'address_verification_status_failed',

        UTILITY_BILL_PAYMENT_CHECK_INITIATIED: 'Utility_Bill_Payment_Check_initiated',
        UTILITY_BILL_PAYMENT_CHECK_SUCCESSS: 'Utility_Bill_Payment_Check_success',
        UTILITY_BILL_PAYMENT_CHECK_FAILED: 'Utility_Bill_Payment_Check_failed',

        GET_DOCUMENT_TYPES_INITIATIED: 'Get_Document_Types_initiated',
        GET_DOCUMENT_TYPES_SUCCESSS: 'Get_Document_Types_success',
        GET_DOCUMENT_TYPES_FAILED: 'Get_Document_Types_failed',

        UPLOAD_POA_DOCUMENT_INITIATIED: 'Upload_PoA_document_initiated',
        UPLOAD_POA_DOCUMENT_SUCCESSS: 'Upload_PoA_document_success',
        UPLOAD_POA_DOCUMENT_FAILED: 'Upload_PoA_document_failed',

        FETCH_POA_DOCUMENT_INFORMATION_INITIATIED: 'Fetch_PoA_document_information_initiated',
        FETCH_POA_DOCUMENT_INFORMATION_SUCCESSS: 'Fetch_PoA_document_information_success',
        FETCH_POA_DOCUMENT_INFORMATION_FAILED: 'Fetch_PoA_document_information_failed',

        EDIT_METER_DOCUMENT_ID_INITIATIED: 'Edit_Meter_Document_ID_initiated',
        EDIT_METER_DOCUMENT_ID_SUCCESSS: 'Edit_Meter_Document_ID_success',
        EDIT_METER_DOCUMENT_ID_FAILED: 'Edit_Meter_Document_ID_failed',


        POA_DOCUMENT_SUBMISSION_INITIATIED: 'PoA_document_Submission_initiated',
        POA_DOCUMENT_SUBMISSION_SUCCESSS: 'PoA_document_Submission_success',
        POA_DOCUMENT_SUBMISSION_FAILED: 'PoA_document_Submission_failed',

        DETECT_USER_ADDRESS_INITIATED: 'Detect_User_Address_initiated',
        DETECT_USER_ADDRESS_SUCCESS: 'Detect_User_Address_success',
        DETECT_USER_ADDRESS_FAILED: 'Detect_User_Address_failed',

        ADDRESS_VERIFICATION_SUBMISSION_INITIATED: 'Address_Verification_Submission_initiated',
        ADDRESS_VERIFICATION_SUBMISSION_SUCCESS: 'Address_Verification_Submission_success',
        ADDRESS_VERIFICATION_SUBMISSION_FAILED: 'Address_Verification_Submission_failed',


    },
    [KycLevel.LEVEL_4]: {},
} as const;

export const isValidKycLevelEvent = (event: KycOnboardingEvent) => {
    const validKycEvents = new Set(Object.values(KYC_EVENTS).reduce<string[]>((acc, val) => acc.concat(Object.values(val)), []));
    return validKycEvents.has(event);
};

export interface AnalyticsPayload {
    event: KycOnboardingEvent;
    api_error_message?: string;
    api_error_code?: string | number;
    [key: string]: unknown;
}

export interface EventPayload {
    event: KycOnboardingEvent;
    eventData?: Record<string, unknown>;
    keysToInclude?: string[];
    error?: HttpErrorResponse;
}
